<template>
  <div>
    <login-snackbar></login-snackbar>
    <change-password></change-password>
  </div>
</template>

<script>
import LoginSnackbar from "./LoginSnackbar";
import ChangePassword from "./ChangePassword";
export default {
  components: {
    LoginSnackbar,
    ChangePassword
  }
};
</script>
